import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RewardForm from '../../../components/forms/RewardForm';
import { RewardClient, RewardDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const RewardEdit: React.FC = () => {
  const [entityData, setEntityData] = useState<RewardDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new RewardClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Rewards', href: '/admin/rewards' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await apiClient.getRewardById(id!);
        setEntityData(response.data || null);
      } catch (error) {
        console.error('Error fetching Reward data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    setIsSubmitting(true);
    try {
      await apiClient.updateReward(id!, data);
      navigate('/admin/rewards');
    } catch (error) {
      console.error('Error updating Reward:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      title="Edit Rewards"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        {entityData ? (
          <RewardForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/rewards')}
          />
        ) : (
          <p>Loading...</p>
        )}
      </Card>
    </AdminLayout>
  );
};

export default RewardEdit;
